import doorIndex from '@/pages/door/index.vue'
import doorList from '@/pages/door/doorList.vue'
import doorDetail from '@/pages/door/doorDetail.vue'
const appRoutes = [{
	path: '/door',
	redirect: '/door/doorList',
	component: doorIndex,
	children: [{
		path: 'doorList',
    name: 'doorList',
		component: doorList
	},{
		path: 'doorDetail',
    name: 'doorDetail',
		component: doorDetail
	}]
}]
export default appRoutes

